import React, { useState } from "react";

const GenerateTab = ({ handleLayoutChange, selectedLayout,updateQRCodeTabData,qrCodeTabData }) => {
    const [generateType, setGenerateType] = useState(qrCodeTabData.generate_type);
    const [generateTypeDropdownOpen, setGenerateTypeDropdownOpen] = useState(false);
    const [generateUrl, setShowGenerateUrl] = useState(qrCodeTabData.generate_url);
    const [generateLocation, setShowGenerateLocation] = useState(qrCodeTabData.generate_location);

    // Handlers Generate Type Change
    const handleGenerateTypeChange = (type) => {
        setGenerateType(type);
        updateQRCodeTabData("generate_type", type);
        setGenerateTypeDropdownOpen(false);
    };

    // Handlers Show Generate Url Change
    const handleShowGenerateUrlChange = (e) => {
        const value = e.target.value;
        setShowGenerateUrl(value);
        updateQRCodeTabData("generate_url", value); 
    };

    // Handlers Show Generate Location Change
    const handleShowGenerateLocationChange = (e) => {
        const value = e.target.value;
        setShowGenerateLocation(value);
        updateQRCodeTabData("generate_location", value); 
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Generate QR Code</span>
                    <div className="color-pikr-box" onClick={() => setGenerateTypeDropdownOpen(!generateTypeDropdownOpen)}>
                        <em>{generateType}</em>
                        {generateTypeDropdownOpen && (
                            <ul className="dropdown-list">
                                {["URL","Location"].map((type) => (
                                    <li key={type} onClick={() => handleGenerateTypeChange(type)}>
                                        {type}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>

            {generateType === "URL" && (
                <div className="side-baar-box-header">
                    <div className="side-baar-box-header">
                        <div className="box-header-row input-fild">
                            <label>Url</label>
                            <input type="text" value={generateUrl} onChange={handleShowGenerateUrlChange}placeholder="" />
                        </div>
                    </div>
                </div>
            )}

            {generateType === "Location" && (
                <div className="side-baar-box-header">
                    <div className="side-baar-box-header">
                        <div className="box-header-row input-fild">
                            <label>Location</label>
                            <input type="text" value={generateLocation} onChange={handleShowGenerateLocationChange} placeholder="" />
                        </div>
                    </div>
                    <p>Set your address to display your location on Google Maps after scanning.</p>
                </div>
            )}
        </div>
    );
};

export default GenerateTab;